import React from 'react';
import './styles/theme.css';
import './styles/global.css';
import SectionNav from './components/SectionNav';
import Hero from './components/Hero';
import Gallery from './components/Gallery';
import Contact from './components/Contact';

const App = () => {
  return (
    <div className="app">
      <SectionNav />
      <Hero />
      <Gallery />
      <Contact />
    </div>
  );
};

export default App;
